import * as Yup from 'yup';

const addOnProductVariantSchema = Yup.object().shape({
  addonCategoryId: Yup.string().required('Category is required.'),
  addonProductId: Yup.string().required('Product is required.'),
  position: Yup.number()
    .min(1, "Please enter more than 1")
    .typeError("Must be Number"),
  stock: Yup.number()
    .required("Stock is required.")
    .typeError("Must be Number"),
  price: Yup.number()
    .required("Price is required.")
    .typeError("Must be Number"),
});

export default addOnProductVariantSchema;